module.exports = __webpack_public_path__ + "static/media/arrow-off-oeste.4a134cd9.png";